var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_16162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 4.375H12.3911C12.4783 4.37496 12.5635 4.40097 12.6358 4.44969C12.7081 4.49841 12.7642 4.56762 12.7969 4.64844L13.5625 6.5625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 7.875H10.0625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.8125C11.2249 11.8125 11.8125 11.2249 11.8125 10.5C11.8125 9.77513 11.2249 9.1875 10.5 9.1875C9.77513 9.1875 9.1875 9.77513 9.1875 10.5C9.1875 11.2249 9.77513 11.8125 10.5 11.8125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.8125C5.09987 11.8125 5.6875 11.2249 5.6875 10.5C5.6875 9.77513 5.09987 9.1875 4.375 9.1875C3.65013 9.1875 3.0625 9.77513 3.0625 10.5C3.0625 11.2249 3.65013 11.8125 4.375 11.8125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 10.5H5.6875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 6.5625H13.5625V10.0625C13.5625 10.1785 13.5164 10.2898 13.4344 10.3719C13.3523 10.4539 13.241 10.5 13.125 10.5H11.8125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 10.5H1.75C1.63397 10.5 1.52269 10.4539 1.44064 10.3719C1.35859 10.2898 1.3125 10.1785 1.3125 10.0625V3.9375C1.3125 3.82147 1.35859 3.71019 1.44064 3.62814C1.52269 3.54609 1.63397 3.5 1.75 3.5H10.0625V9.26242",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_16162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.c7ee2391c1ed7591f47e4ebf43b914e5.svg";
export { ForwardRef as ReactComponent };